import { render, staticRenderFns } from "./HomeworkAddTextbookQuestion.vue?vue&type=template&id=51b58cf8&scoped=true"
import script from "./HomeworkAddTextbookQuestion.vue?vue&type=script&lang=js"
export * from "./HomeworkAddTextbookQuestion.vue?vue&type=script&lang=js"
import style0 from "./HomeworkAddTextbookQuestion.vue?vue&type=style&index=0&id=51b58cf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b58cf8",
  null
  
)

export default component.exports